var View = require('views/base/view');

module.exports = View.extend({
  autoRender: true,
  className: 'test-page',
  template: require('./templates/test')
});
